<template>
  <div class="symbol-statistics page-box summary-page">
    <div class="header-top">
      <el-row :gutter="10">
        <cent-select
           v-if="centAccountConfig"
           :tabs-type="tabsType"
           @send-type="sendType"
        ></cent-select>
        <el-col
          :lg="8"
          :md="8"
          :sm="12"
          :xs="24"
          class="el-col-el"
        >
          <div class="label">{{$t('Statistics_Time')}}</div>
          <el-date-picker
            v-if="!realMobile"
            style="width: 100%"
            v-model="date"
            @change="toQuery"
            type="daterange"
            value-format="yyyy-MM-dd"
            :range-separator="$t('root.dateTo')"
            :start-placeholder="$t('root.startDate')"
            :end-placeholder="$t('root.endDate')"
          >
          </el-date-picker>
          <select-date-duration
            class="header-sub-item"
            v-model="date"
          ></select-date-duration>
        </el-col>
      </el-row>
    </div>
    <div class="page-content">
      <div class="content-header">
        <el-input
          class="search-input header-item"
          v-model="symbol"
          :placeholder="$t('Trading_symbol')"
          style="margin-right: 10px;width: 200px;"
          clearable
        ></el-input>
        <vs-button
          class="search-btn header-item"
          @click="searchHandle"
        >{{$t('search')}}</vs-button>
      </div>
      <el-table
        v-loading="loading"
        :data="listData"
        size="small"
        style="width: 100%;"
        :empty-text="$t('root.noData')"
        show-summary
        :summary-method="getSummaries"
        :sort-change="sortChange"
        :header-cell-style="{ background: '#F3F2F7',color: '#5E5873' }"
        :default-sort="{prop: 'openingLots', order: 'descending'}"
        class="small-el-table"
      >
        <el-table-column
           prop="id"
           :label="$t('serial_number')"
        />

        <el-table-column
          :label="$t('Trading_symbol')"
          prop="symbol"
        >
        </el-table-column>
        <el-table-column
          :label="$t('Number_of_trading_accounts')"
          sortable
          min-width="120"
          prop="accountNumber"
        >
        </el-table-column>
        <el-table-column
          :label="$t('Opening_lot')"
          sortable
          prop="openingLots"
          min-width="120"
        >
        </el-table-column>
        <el-table-column
          :label="$t('Number_of_lots_to_close_position')"
          sortable
          prop="closedLots"
          min-width="125"
        >
        </el-table-column>
        <el-table-column
          :label="$t('User.fee')"
          sortable
          min-width="100"
          prop="commission"
        >
        </el-table-column>
        <el-table-column
          :label="$t('User.reportStorage')"
          sortable
          prop="swap"
        >
        </el-table-column>
        <el-table-column
          :label="$t('User.reportProfit')"
          sortable
          prop="profit"
        >
          <template slot-scope="scope">
            <span
              class="profit-span"
              :class="{green: getProfitColor(scope.row)}"
            >{{scope.row.profit}}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">{{$t('total')}} {{total}} {{$t('item')}}</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getMt4Group } from '@/api/userCenter.js'
import { mapGetters } from 'vuex'
import {parseTime, getIsMoreThreeMonth, init_date} from '@/utils/index';

// 表格字段需要重新调 todo
import initData from "@/mixins/initData";
import queryHeader from "@/components/traderReport/queryHeader";
export default {
  name: "index",
  components: {
    queryHeader,
  },
  data() {
    return {
      tabsType: 'USD',
      date: '',
      symbol: '',
      statistics: {
         tradeAccNum: '',
         openValunm: '',
         closeValunm: '',
         fee: '',
         storee: '',
         pofit: '',
      },
      centAccountConfig: false,
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['userInfo','realMobile']),
  },
  created(){
    this.dateInit();
  },
  mounted(){
    this.getMt4Group();
    this.init();
  },
  methods: {
    sendType(tabsType){
      this.tabsType = tabsType;
      this.page = 1;
      this.init();
    },
    getMt4Group() {
      getMt4Group({
        isMock: 2
      }).then((res) => {

        this.centAccountConfig = res.data.some((item) => {
          return item.groupName == 'Cent';
        });
      });
    },
    dateInit(){
      this.date = [init_date().oneMonAgo,init_date().today];
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        switch (column.property) {
          case 'id':
            sums[index] = this.$t('User.total');
            break;
          case 'symbol':
            sums[index] = `-`;
            break;
          case 'accountNumber':
            sums[index] = `${this.statistics.totalAccount}`;
            break;
          case 'openingLots':
            sums[index] = `${this.statistics.totalOpeningLots}`;
            break;
          case 'closedLots':
            sums[index] = `${this.statistics.totalClosedLots}`;
            break;
          case 'commission':
            sums[index] = `${this.statistics.totalCommission}`;
            break;
          case 'swap':
            sums[index] = `${this.statistics.totalSwap}`;
            break;
          case 'profit':
            sums[index] = `${this.statistics.totalProfit}`;
            break;
        }
      });
      return sums;
    },
    beforeInit(){
      this.url = '/crm/reception/partner/symbolStatistics';
      this.params = {
        page: this.page - 1,
        size: this.size,
      }

      // 添加时间
      if(this.symbol){
        this.params.symbol = this.symbol;
      }
      this.params.currency = this.tabsType;
      if(this.date && this.date.length){
        if(getIsMoreThreeMonth(this.date[0],this.date[1])){
          this.$message({
            type: 'error',
            message: this.$t('A_maximum_of_three_months_can_be_queried')
          })
          return false;
        }else {
          this.params.startTime = this.date[0];
          this.params.endTime = this.date[1];
        }
      }
      if(!this.date || !this.date.length){
        this.$message({
          type: 'error',
          message: this.$t('Please_select_a_start_and_end_date')
        })
        return false;
      }
      return true;
    },
    getProfitColor(item){
      return item.profit < 0;
    },
    getType(item){
      return item.cmd  % 2 == 0 ? this.$t('User.buy') : this.$t('User.sell');
    },
    searchHandle(){
      this.page = 1;
      this.init();
    }
  },
}
</script>

<style lang="scss" scoped>
.symbol-statistics {

  .profit-span {
    color: #41B883;
    &.green {
      color:#D85E5F;
    }
  }
  .content-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    .header-item {
      margin: 0 5px 10px 5px;
    }
  }
  .el-table {
  }
}
.header-top {
  background-color: #ffffff;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 24px;
}
</style>
<style lang="scss">
// 合计数据样式
.symbol-statistics {
  .el-table {
    display: flex;
    flex-direction: column;
  }
  /* order默认值为0，只需将表格主体order设为1即可移到最后，合计就上移到最上方了 */
  .el-table__body-wrapper {
    order: 1;
  }
  .el-table__footer {
    td.el-table__cell {
      background-color: #F3F2F7;
    }
  }
}
</style>
